module.exports = __webpack_public_path__ + "static/media/about-img2.c3fbda42.svg";